module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/ogp-1a6559cf761c22a746c625ccb7e2e1e9.webp";